const config = {
	// url: 'http://localhost/work/content/public/bco2/'
	url: 'https://apicontrol.perindustrianshunhon.com/public/bco2/'
}

export default config;